<template>
  <v-row>
    <v-col cols="12">
      <swiper
        :options="swiperOption"
        style="width: 100%;"
      >
        <template v-for="(item, idx) in items">
          <swiper-slide
            :key="`slide-${idx}`"
            class="transparent"
          >
            <div style="width: 100%; height: auto;">
              <v-card
                :href="item.Link || '#'"
                :target="item.Target || '_self'"
                color="transparent"
                flat
              >
                <video
                  v-if="item.Type === 'video'"
                  :poster="item.Poster"
                  :src="item.Src"
                  autoplay="autoplay"
                  defaultMuted
                  loop="loop"
                  muted
                  oncontextmenu="return false;"
                  playsinline
                  preload="auto"
                  style="width: 100%; height: auto; max-height: 420px; object-fit: cover; object-position: center center;"
                />

                <img
                  v-if="item.Type === 'image'"
                  :src="item.Src"
                  style="width: 100%; height: auto; max-height: 420px; object-fit: cover; object-position: center center;"
                >
              </v-card>
            </div>
          </swiper-slide>
        </template>

        <div
          v-if="pagination"
          slot="pagination"
          class="swiper-pagination"
        />

        <template v-if="buttons">
          <div
            slot="button-prev"
            class="swiper-button-prev"
          >
            <i
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-arrow-left"
              data-v-0bc8037b=""
            />
          </div>

          <div
            slot="button-next"
            class="swiper-button-next"
          >
            <i
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-arrow-right"
              data-v-0bc8037b=""
            />
          </div>
        </template>
      </swiper>
    </v-col>
  </v-row>
</template>

<script>
import GeneralSliderMixin from '@/theme/default/views/home/GeneralSlider.js'

export default {
  name  : 'GeneralSlider',
  mixins: [GeneralSliderMixin]
}
</script>

<style scoped src="@/theme/default/views/home/GeneralSlider.css"></style>
<style scoped>
</style>
